var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "el-section" }, [
    _c(
      "div",
      {
        staticClass:
          "emd-container _highlight_header _header_spaced _footer_spaced_sm",
      },
      [
        _c("div", { staticClass: "emd-container__header" }, [
          _c("h2", { staticClass: "emd-text _size_section" }, [
            _vm._v(" " + _vm._s(_vm.$t("customer.subscriptions.title")) + " "),
          ]),
        ]),
        _vm.loadingList
          ? _c(
              "div",
              { staticClass: "eu-pa_6 eu-align_center" },
              [_c("emd-loader", { attrs: { type: "_invert" } })],
              1
            )
          : _c(
              "div",
              { staticClass: "emd-table-responsive" },
              [
                _c("Table", {
                  attrs: {
                    fields: _vm.fields,
                    items: _vm.subscriptions.items,
                    toDetail:
                      _vm.permissionIsEnabled("subscription:get") &&
                      _vm.toDetail,
                  },
                }),
                !_vm.loadingList && _vm.showEmptyList()
                  ? _c("empty-list", { attrs: { entity: "subscriptions" } })
                  : _vm._e(),
              ],
              1
            ),
        !_vm.loadingList
          ? _c("pagination", {
              attrs: {
                pagination: _vm.subscriptions.pagination,
                totalShowing: _vm.totalItems,
                type: "list",
                action: _vm.action,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }